import { useState } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import FormLayout from '../../../../components/auth/FormLayout';
import LoginStep from '../../../../components/auth/steps/LoginStep';
import LoadingStep from '../../../../components/auth/steps/LoadingStep';

type Step = 'login' | 'loading';

export default function LoginTemplate() {
  const [currentStep, setCurrentStep] = useState<Step>('login');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // organization_user[field] の形式から field を抽出
    const fieldName = name.includes('[') ? name.split('[')[1].replace(']', '') : name;

    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleSubmit = () => {
    setCurrentStep('loading');
    // Simulate API call
    setTimeout(() => {
      console.log('Login completed:', formData);
      // TODO: Redirect to dashboard after successful login
    }, 2000);
  };

  const canProceed = () => {
    return formData.email && formData.password;
  };

  const renderContent = () => {
    switch (currentStep) {
      case 'login':
        return (
          <LoginStep
            formData={formData}
            onInputChange={handleInputChange}
            onSubmit={handleSubmit}
            canProceed={!!canProceed()}
          />
        );
      case 'loading':
        return <LoadingStep />;
      default:
        return (
          <LoginStep
            formData={formData}
            onInputChange={handleInputChange}
            onSubmit={handleSubmit}
            canProceed={!!canProceed()}
          />
        );
    }
  };

  const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
  const siteKey = recaptchaSiteKey || 'dummy-key-for-development';

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <FormLayout>{renderContent()}</FormLayout>
    </GoogleReCaptchaProvider>
  );
}
